import LoginComponent from "../../components/login/login.component";

const LoginPage = () => {
  return <LoginComponent />
}

export default LoginPage;